//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as communityQaAction from '../action/communityQaAction';

//Icon
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
//Part

//Dialog
import DialogCommunityQaStatisticsUser from './DialogCommunityQaStatisticsUser';


class Comp extends React.Component {

  constructor(props) {
    super(props);

    let sum = 0;
    props.statistics.forEach(function(value) {
      sum += value.answer_cnt;
    });
    this.state = {
      sum: sum,
      statisticsUserAnswerComment: null,
  	}
  }


  _renderGraph(value, index) {
    let width = 0;

    width = Math.round((value.answer_cnt / this.state.sum) * 100);

    return (
      <div
        key={index}
        style={{margin:'5px'}}
      >
        <div
          style={{
            backgroundColor: '#FFBC57',
            color:'#FFF',
            width: width + '%',
            minWidth:'50px',
            cursor:'pointer',
            textAlign:'right'
          }}
          className='round12'
          onClick={
            () => this.setState({
              statisticsUserAnswerComment: value.answer_comment,
            })
          }
        >
          {value.answer_cnt}
          <ArrowRightIcon style={{verticalAlign:'middle'}}/>
        </div>
        {value.answer_comment}

      </div>
    )
  }


	render() {
		return (
			<div>
        {
          (this.props.statistics.length > 0) ? (
            this.props.statistics.map((value, index) =>
              this._renderGraph(value, index)
            )
          ): (
            <div style={{color:'#666'}}>
              回答が見つかりませんでした。
            </div>
          )
        }
        <DialogCommunityQaStatisticsUser
          open={(this.state.statisticsUserAnswerComment) ? true : false}
          close={
            () => this.setState({
              statisticsUserAnswerComment: null,
            })
          }
          qaId={this.props.qaId}
          answerComment={this.state.statisticsUserAnswerComment}
        />
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		communityQa: state.communityQa,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...communityQaAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
